<template>
  <!-- TODO: revisar y añadir links propios con router-link -->
  <footer class="footer">
    <div class="footer-container">
      <div class="column-1">
        <component :is="`h${numHeader}`" class="footer-title">{{
          $t("general.footer.aboutUs")
        }}</component>
        <ul>
          <li>
            <a
              :href="
                '/' +
                  hasRegion(route.params.region) +
                  $t('general.footer.links.howItWorks')
              "
              >{{ $t("general.footer.howItWorks") }}</a
            >
          </li>
          <!-- <li>
            <a href="">{{ $t("general.footer.brandingAds") }}</a>
          </li>
          <li>
            <a href="">{{ $t("general.footer.news") }}</a>
          </li> -->
          <li>
            <a :href="'/' + hasRegion(route.params.region) + '/magazine'">{{
              $t("general.footer.wegowMag")
            }}</a>
          </li>
          <!-- TODO: Cuando esté la landing -->
          <!-- <li>
            <a href="https://www.wegow.com/landing/weswap/">{{
              $t("general.footer.weSwap")
            }}</a>
          </li> -->
          <li>
            <a
              href="https://www.wegow.com/es-es/conciertos/geo/espana?bono_cultural=true"
              >{{ $t("general.footer.cultural") }}</a
            >
          </li>
        </ul>
      </div>
      <div class="column-2">
        <component :is="`h${numHeader}`" class="footer-title">{{
          $t("general.footer.sellWithUs")
        }}</component>
        <ul>
          <li>
            <w-navigation
              v-if="!isAuth"
              :params="{
                name: 'SignUpPromoter',
                params: {
                  region: hasRegion(route.params.region) || 'es'
                }
              }"
              :full="false"
            >
              <template #link>
                {{ $t("general.footer.uploadEvents") }}
              </template>
            </w-navigation>
            <a v-else :href="backofficeUrl">
              {{ $t("general.footer.uploadEvents") }}
            </a>
          </li>
          <li>
            <a href="https://www.wegowprovenues.com/find-your-venue">{{
              $t("general.footer.uploadVenue")
            }}</a>
          </li>
          <li>
            <a
              href="https://bracelit.es/control-de-accesos/bracelit-el-sistema-tecnologico-definitivo-para-la-gestion-de-eventos"
              >{{ $t("general.footer.accessControl") }}</a
            >
          </li>
          <li>
            <a
              href="https://bracelit.es/pagos-cashless/bracelit-el-sistema-de-pagos-cashless-para-eventos"
              >{{ $t("general.footer.cashlessPayments") }}</a
            >
          </li>
          <li>
            <a href="https://affiliates.wegow.com/affiliates">{{
              $t("general.footer.membership")
            }}</a>
          </li>
          <li>
            <a
              v-if="userDetail.is_staff || userDetail.promoter_status > 0"
              :href="backofficeUrl"
            >
              <span>{{ $t("general.header.dropdown.user.backoffice") }}</span>
            </a>
          </li>
          <li>
            <a
              :href="
                agent
                  ? 'https://apps.apple.com/es/app/wegow-conciertos/id1228326087'
                  : 'https://play.google.com/store/apps/details?id=com.wegow.weaccess&hl=es_419&gl=US'
              "
              target="_blanket"
              >WeAccess</a
            >
          </li>
        </ul>
      </div>
      <div class="column-3">
        <component :is="`h${numHeader}`" class="footer-title">{{
          $t("general.footer.support")
        }}</component>
        <ul>
          <li>
            <a
              :href="
                '/' +
                  hasRegion(route.params.region) +
                  $t('general.footer.links.help')
              "
              >{{ $t("general.footer.help") }}</a
            >
          </li>
          <li>
            <a
              :href="
                '/' +
                  hasRegion(route.params.region) +
                  $t('general.footer.links.help')
              "
            >
              {{ $t("general.footer.notFoundTickets") }}</a
            >
          </li>
          <li>
            <a
              :href="
                '/' +
                  hasRegion(route.params.region) +
                  $t('general.footer.links.contact')
              "
            >
              {{ $t("general.footer.contactWithUs") }}</a
            >
          </li>
        </ul>
      </div>
      <div class="column-4">
        <component :is="`h${numHeader}`" class="footer-title">{{
          $t("general.footer.legal")
        }}</component>
        <ul>
          <li>
            <a
              :href="
                '/' +
                  hasRegion(route.params.region) +
                  $t('general.footer.links.terms')
              "
              >{{ $t("general.footer.useConditions") }}</a
            >
          </li>
          <li>
            <a
              :href="
                '/' +
                  hasRegion(route.params.region) +
                  $t('general.footer.links.legal')
              "
              >{{ $t("general.footer.privacyPolicy") }}</a
            >
          </li>
          <li>
            <w-navigation
              :params="{
                name: 'CookiesPage',
                params: {
                  region: hasRegion(route.params.region) || 'es'
                }
              }"
              :full="false"
            >
              <template #link>
                {{ $t("general.footer.policyCookies") }}
              </template>
            </w-navigation>
          </li>
        </ul>
      </div>
      <div class="column-5">
        <component :is="`h${numHeader}`" class="footer-title">{{
          $t("general.footer.language")
        }}</component>
        <language-selector
          background-select="background-transparent"
          color-font="#D8D8D8"
        />
        <component :is="`h${numHeader}`" class="footer-title">{{
          $t("general.footer.region")
        }}</component>
        <region-selector
          id-selector="footer-region-selector"
          :show-button="false"
          background-select="background-transparent"
          color-font="#D8D8D8"
        ></region-selector>
      </div>

      <cities-footer></cities-footer>
      <genres-footer></genres-footer>
      <cities-footer type="festivals"></cities-footer>
      <genres-footer type="festivals"></genres-footer>
      <cities-footer type="venues"></cities-footer>

      <div class="column-1-3">
        <component
          :is="`h${numHeader}`"
          class="footer-title md:mb-[15px] mb-2"
          >{{ $t("general.footer.followUs") }}</component
        >
        <ul class="logo-container">
          <li>
            <a href="https://www.instagram.com/wegowes/">
              <img
                :src="require('@/assets/images/ic-instagram-topaz.svg')"
                :alt="$t('general.brandLogo', { brand: 'Instagram' })"
                height="24"
                width="24"
                loading="lazy"
              />
            </a>
          </li>
          <li>
            <a href="https://www.tiktok.com/@wegowes">
              <img
                :src="require('@/assets/images/ic-tiktok-topaz.svg')"
                :alt="$t('general.brandLogo', { brand: 'TikTok' })"
                height="24"
                width="24"
                loading="lazy"
              />
            </a>
          </li>
          <li>
            <a href="https://twitter.com/wegowes">
              <img
                :src="require('@/assets/images/ic-x-topaz.svg')"
                :alt="$t('general.brandLogo', { brand: 'Twitter' })"
                height="24"
                width="24"
                loading="lazy"
              />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCrftSfN7u5GNiHDy4bBtxHg">
              <img
                :src="require('@/assets/images/ic-youtube-topaz.svg')"
                :alt="$t('general.brandLogo', { brand: 'Youtube' })"
                height="24"
                width="24"
                loading="lazy"
              />
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/wegow.es/">
              <img
                :src="require('@/assets/images/ic-facebook-topaz.svg')"
                :alt="$t('general.brandLogo', { brand: 'Facebook' })"
                height="24"
                width="24"
                loading="lazy"
              />
            </a>
          </li>
          <li>
            <a href="https://es.linkedin.com/company/wegow">
              <img
                :src="require('@/assets/images/ic-linkedin-topaz.svg')"
                :alt="$t('general.brandLogo', { brand: 'Linkedin' })"
                height="24"
                width="24"
                loading="lazy"
              />
            </a>
          </li>
          <li>
            <a href="https://open.spotify.com/user/wegow">
              <img
                :src="require('@/assets/images/ic-spotify-topaz.svg')"
                :alt="$t('general.brandLogo', { brand: 'Spotify' })"
                height="24"
                width="24"
                loading="lazy"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="column-3-3">
        <component
          :is="`h${numHeader}`"
          class="footer-title md:mb-[15px] mb-2"
          >{{ $t("general.footer.apps") }}</component
        >
        <ul class="app-container">
          <li>
            <a
              href="https://apps.apple.com/es/app/wegow-conciertos-y-festivales/id1228326087"
            >
              <img
                :src="require('@/assets/images/apple-store-banner.svg')"
                loading="lazy"
                width="100"
                height="32"
                :alt="$t('general.brandLogo', { brand: 'Apple Store' })"
              />
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.wegow.wegow&hl=es&gl=US&pli=1"
            >
              <img
                :src="require('@/assets/images/android-store-banner.svg')"
                loading="lazy"
                width="100"
                height="32"
                :alt="$t('general.brandLogo', { brand: 'Android Store' })"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="column-5-3">
        <img
          src="https://cdn.wegow.com/no-delete/wegow/wegow-conciertos.svg"
          class="lazyload wegow-logo"
          height="50"
          width="44"
          alt="Logo Wegow"
        />
        <p class="wegow-info">@ {{ year }} Wegow. All rights reserved.</p>
        <address class="wegow-info">
          Gran Vía Don Diego López de Haro 17 48001, Bilbao (Bizkaia)
        </address>
      </div>
    </div>
    <div class="botton-row">
      <!-- TODO: revisar :style="timezone === 'Europe/Madrid' ? 'max-width: 900px' : ''" -->
      <div class="wegow-logos-awards">
        <div class="max-width-main-container">
          <div class="logo-item">
            <div class="logo">
              <img
                :src="
                  require('@/assets/images/on-bizkaia-transparent-letter.svg')
                "
                loading="lazy"
                style="height: 54px;width: 52px;"
                alt="On Bizkaia logo"
              />
            </div>
            <div class="text">
              <p v-html="$t('general.footer.bestTrajectory')" />
            </div>
          </div>
          <div class="logo-item">
            <div class="logo">
              <img
                :src="require('@/assets/images/cepyme-logo.svg')"
                style="height: 45px;width: 45px;"
                loading="lazy"
                alt="Cepyme logo"
              />
            </div>
            <div class="text">
              <p v-html="$t('general.footer.bestProyect1')" />
              <p v-html="$t('general.footer.bestProyect2')" />
            </div>
          </div>
          <div class="logo-item">
            <div class="logo">
              <img
                :src="require('@/assets/images/enisa.webp')"
                style="height: 45px;width: 28px;"
                loading="lazy"
                alt="Enisa logo"
              />
            </div>
            <div class="text">
              <p>{{ $t("general.footer.financedByEnisa") }}</p>
            </div>
          </div>
          <a
            v-if="timezone === 'Europe/Madrid'"
            class="logo-item"
            href="https://www.wegow.com/es-es/conciertos/geo/espana?bono_cultural=true"
          >
            <div class="logo">
              <figure class="picture">
                <picture>
                  <img
                    :src="require('@/assets/images/ministry.webp')"
                    loading="lazy"
                    style="height: 30px;width: 90px;"
                    alt="Ministerio de cultura"
                  />
                </picture>
              </figure>
            </div>
            <div class="text">
              <p>{{ $t("general.footer.cultureMinistry") }}</p>
            </div>
          </a>
          <a
            v-if="timezone === 'Europe/Madrid'"
            class="logo-item"
            href="https://www.wegow.com/es-es/conciertos/geo/espana?bono_cultural=true"
          >
            <div class="logo">
              <figure class="picture">
                <picture>
                  <img
                    :src="require('@/assets/images/cultural-bonus-ic.webp')"
                    loading="lazy"
                    style="height: 46px;width: 49px;"
                    alt="Icono Bono Cultural Joven"
                  />
                </picture>
              </figure>
            </div>
            <div class="text">
              <p>{{ $t("general.footer.youthCulturalBonus") }}</p>
            </div>
          </a>
        </div>
      </div>
      <!-- v-if="links.terms_and_conditions || links.privacy" -->
      <!-- <div class="footer-texts">
        <p>
          <a
            :href="links.terms_and_conditions"
            :title="$t('general.footer.termsAndConditions')"
            target="_blank"
            >{{ $t("general.footer.termsAndConditions") }}</a
          >
          <a
            :href="links.privacy"
            :title="$t('general.footer.privacyPolicy')"
            target="_blank"
            >{{ $t("general.footer.privacyPolicy") }}</a
          >
          c/ Nervión 3, 6º 48001, Bilbao, España
        </p>
      </div> -->
    </div>
    <div class="column-5-3 mobile-version">
      <img
        :src="require('@/assets/images/wegow-conciertos.svg')"
        class="lazyload wegow-logo"
        height="50"
        width="44"
        alt="Logo Wegow"
      />
      <p class="wegow-info">@ {{ year }} Wegow. All rights reserved.</p>
      <address class="wegow-info">
        Gran Vía Don Diego López de Haro 17 48001, Bilbao (Bizkaia)
      </address>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useModalHandler } from "@/plugins/useModalHandler";
import { useRoute } from "vue-router";
import { useUser } from "@/composables/useUser";

import RegionSelector from "@/components/general/forms/complex-forms/RegionSelector";
import LanguageSelector from "@/components/general/forms/complex-forms/LanguageSelector.vue";
import GenresFooter from "@/components/general/ui/footer/GenresFooter.vue";
import CitiesFooter from "@/components/general/ui/footer/CitiesFooter.vue";
import WNavigation from "@/components/general/ui/WNavigation";

const { userDetail, isAuth, closeSession } = useUser();
const { openModal, SIGN_UP_PROMOTER } = useModalHandler();
const year = new Date().getFullYear();
const agent = ref(false);
const timezone = ref("Europe/Madrid");
const route = useRoute();
const numHeader = ref(5);
const backofficeUrl = process.env.VUE_APP_BACKOFFICE;

onMounted(() => {
  setTimeout(() => {
    numHeader.value = getNextHeader();
  }, 500);
});
const getNextHeader = () => {
  let header = 1;
  if (document.querySelectorAll("h6:not(.footer-title)").length > 1) {
    header = 6;
  } else if (document.querySelectorAll("h5:not(.footer-title)").length > 1) {
    header = 5;
  } else if (document.querySelectorAll("h4:not(.footer-title)").length > 1) {
    header = 4;
  } else if (document.querySelectorAll("h3:not(.footer-title)").length > 1) {
    header = 3;
  } else if (document.querySelectorAll("h2:not(.footer-title)").length > 1) {
    header = 2;
  } else if (document.querySelectorAll("h1:not(.footer-title)").length > 1) {
    header = 1;
  }
  return header < 6 ? header + 1 : header;
};

// const detectAgent = () => {
//   if (navigator.userAgent.includes("iPhone")) {
//     agent.value = true;
//   } else {
//     agent.value = false;
//   }
// };

// timezone.value = await Intl.DateTimeFormat()
//   .resolvedOptions()
//   .timeZone.trim();
const hasRegion = region => {
  if (region) {
    return region;
  } else {
    return "es";
  }
};
</script>

<style scoped lang="scss">
@media screen and (max-width: $screen-sm) {
  .app-container img {
    width: 90%;
  }
  .app-container li {
    margin-right: unset !important;
  }
  .logo-container li {
    margin-right: 6px !important;
  }
  .mobile-version {
    display: block !important;
    padding: 23px 75px 21px 75px;
  }
  .wegow-logos-awards {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
  .footer-container {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .column-2 {
    grid-column: 1 !important;
    grid-row: 2;
  }
  .column-3 {
    grid-column: 2 !important;
    grid-row: 1;
  }
  .column-4 {
    grid-column: 2 !important;
    grid-row: 2;
  }
  .column-5 {
    grid-column: 2 !important;
    grid-row: 3;
  }

  .column-5-3 {
    display: none;
  }
  .column-3-3 {
    grid-column: 2 !important;
    grid-row: 5;
  }
  .column-1-3 {
    grid-column: 2 !important;
    grid-row: 6;
  }
}
.logo-container img {
  aspect-ratio: 1;
}
.footer {
  min-height: 370px !important;
  width: 100%;
  background-color: $backgroundGrey;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white !important;
  padding-top: 57px;
  margin-top: auto;
}
.botton-row {
  width: 100%;
  margin: auto;
  text-align: center;
  // @media screen and (min-width: 768px) {
  //   width: 60%;
  // }
  .wegow-logos-awards {
    background-color: $inputLigthBackground;
    padding-left: 247px;
    padding-right: 247px;
    padding: 34px 0 45px 0;
    // @media screen and (max-width: 576px) {
    //   flex-direction: column;
    // }
    .max-width-main-container {
      display: flex;
      justify-content: space-around;
    }
    .logo-item {
      flex: 1;
      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        text-align: center;
        margin-bottom: 10px;
        img:not(.awards) {
          height: 50px;
          width: auto;
        }
        .awards {
          width: 90%;
          max-width: 140px;
        }
      }
      .text {
        text-align: center;
        p {
          font-size: 12px;
          color: $textosecundario;
        }
      }
    }
  }
  .footer-texts {
    text-align: center;
    padding-bottom: 10px;
    p,
    a {
      font-size: 12px;
      color: $textosecundario;
      margin: 0;
    }
  }
}
.footer-container {
  line-height: 20px;
  max-width: 1200px;
  width: 100%;
  display: grid;
  // grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  row-gap: 37px;
  grid-auto-rows: minmax(100px);
  margin-bottom: 48px;
  @media screen and (max-width: 1200px) {
    padding-left: 10% !important;
    padding-right: 10% !important;
  }
  @media screen and (max-width: $screen-sm) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  li {
    @media screen and (max-width: $screen-md) {
      padding: 6px 0;
    }
  }
  h5 {
    margin-bottom: 7px;
  }
  a {
    font-size: 14px;
    color: $textosecundario;
    font-weight: 400;
    @media screen and (max-width: $screen-md) {
      font-size: 18px;
      font-weight: 300;
      color: $textosecundario;
      display: block;
    }
  }
}
.column-1 {
  grid-column: 1;
}
.column-2 {
  grid-column: 2;
}
.column-3 {
  grid-column: 3;
}
.column-4 {
  grid-column: 4;
}
.column-5 {
  grid-column: 5;
}
.column-1-2 {
  grid-column: 1/4;
}
.column-3-2 {
  grid-column: 4/6;
}
.column-3-2 ul {
  grid-template-columns: repeat(2, 1fr);
}

.footer-title {
  font-weight: 600;
  margin-bottom: 7px;
}
.column-1-2,
.column-3-2 {
  margin-bottom: 48px;
}
// .column-1-2 ul,
// .column-3-2 ul {
//   display: flex;
//   flex-wrap: wrap;
// }
.column-1-2 ul li,
.column-3-2 ul li {
  margin-right: 20px;
}

.column-1-3 {
  grid-column: 1/3;
}
.column-3-3 {
  grid-column: 3/5;
}
.column-5-3 {
  grid-column: 5;
}
.wegow-logo {
  // width: 44px;
  // height: 50px;
  margin: auto;
  margin-bottom: 20px;
}
.logo-container,
.app-container {
  display: flex;
  align-items: center;
}
.app-container li {
  margin-right: 1rem;
}
.logo-container li {
  margin-right: 14px;
}
.wegow-info {
  font-size: 10px;
  font-style: normal;
  text-align: center;
}
.wegow-info:first-of-type {
  margin-bottom: 9px;
}
.ul-align-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.mobile-version {
  display: none;
}

// img {
//   aspect-ratio: attr()/attr();
// }

// .ul-align-grid:first-of-type {
//   grid-template-columns: repeat(2, 1fr);
// }

// .column-1-2,
// .column-3-2,
// .column-5-2 {
//   margin-top: 24px;
// }
</style>
